























































































































import {Component, Vue, Watch} from "vue-property-decorator";
import Company from "@/model/company";
import QErrors from "@/common/qErrors.vue";
import AccountSearch from "@/components/account/accountSearch.vue";
import AccountCooperationCompleted from "@/components/account/accountCooperationCompleted.vue";
import {namespace} from "vuex-class";
import UserCompany from "@/model/userCompany";
import User, {USER_ROLE} from "@/model/user";
import QCompanySelect from "@/common/qCompanySelect.vue";
import QUserRoleSelect from "@/common/qUserRoleSelect.vue";
import store from "@/store";
import userApi from "@/api/userApi";
import qNotify from "@/common/qNotify";
import _ from "lodash";
import {compareWithKeys} from "@/common/utils";
const authStore = namespace("Auth");
@Component({
  name: "AccountCooperate",
  components: {
    QErrors,
    AccountSearch,
    AccountCooperationCompleted,
    QCompanySelect,
    QUserRoleSelect,
  },
})
export default class AccountCooperate extends Vue {
  @authStore.Getter
  public getCurrentyCompany!: Company;
  @authStore.Getter
  getUserLogging!: User

  @authStore.Getter
  public isAdmin;
  @authStore.Getter
  public isManager;
  @authStore.Getter
  public isWitness;
  @authStore.Getter
  public isOwner;

  public cooperateIndex: number = null;

  public isShow = false;
  public type = "create";
  public errors = {};
  public userCompany = new UserCompany();
  public userCompanyInit = new UserCompany();

  public show(type, cooperateData = null) {
    this.type = type;
    this.setInitValue(cooperateData);
    this.isShow = true;
  }

  public setInitValue(cooperateData) {
    this.errors = {};
    if (this.isEdit) {
      this.userCompany = new UserCompany(cooperateData.userCompanyCooperation);
      this.cooperateIndex = cooperateData.cooperateIndex;
    } else {
      this.userCompany = new UserCompany();
      this.setCompanyId();
      this.setAffiliationCompanyId();
      this.setRoleId();
    }

    this.userCompanyInit = _.cloneDeep(this.userCompany)
  }

  get isEdit() {
    return this.type === "edit";
  }

  public setRoleId() {
    if (this.isAdmin) {
      this.userCompany.role_id = 0;
    } else {
      this.userCompany.role_id = (this.getCurrentyCompany.pivot.role_id as number);
    }
  }

  get isShowMCompanyName() {
    const roleId = this.userCompany.role_id;
    return roleId == USER_ROLE.MANAGE || (this.isAdmin && (roleId == USER_ROLE.WITNESS || roleId == USER_ROLE.OWNER))
  }

  get isShowWOCompanyName() {
    const roleId = this.userCompany.role_id;
    return roleId == USER_ROLE.WITNESS || roleId == USER_ROLE.OWNER;
  }

  @Watch("userCompany.role_id")
  public refreshCompany() {
    if(this.isEdit) {
      return;
    }
    this.setCompanyId();
    this.setAffiliationCompanyId();
  }

  public setCompanyId() {
    if (this.isAdmin) {
      this.userCompany.company_id = null;
    } else {
      this.userCompany.company_id = this.getCurrentyCompany.id;
    }
  }

  public setAffiliationCompanyId() {
    if (this.isAdmin || (this.isManager && (this.userCompany.role_id == USER_ROLE.WITNESS || this.userCompany.role_id == USER_ROLE.OWNER))) {
      this.userCompany.affiliation_company_id = null;
    } else {
      this.userCompany.affiliation_company_id = this.getCurrentyCompany.pivot.affiliation_company_id;
    }
  }

  public search() {
    (this.$refs.accSearch as AccountSearch).show();
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.isShow = false;
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public async createCooperate() {
    const result = await userApi.createCooperate(this.userCompany);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t("users.cooperation_created_fail"),
      });

      this.errors = result.meta.errors;
    } else {
      qNotify.success({
        text: this.$t("users.cooperation_created"),
      });

      (this.$refs.accCooperationCompleted as AccountCooperationCompleted).show(this.userCompany.user_id);
      this.isShow = false;
    }
  }

  public async deleteCooperate() {
    this.$modal.showDelete({
      text: this.$t("users.delete_cooperation", { user_name: this.userCompany.user_name }),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await userApi.deleteCooperate(this.userCompany.id);
        if (result.meta.status === 200) {
          qNotify.success({
            text: this.$t("users.cooperation_deleted"),
          });
          if(this.isAdmin) {
            store.dispatch("User/spliceCooperate", this.cooperateIndex);
          } else {
            this.$emit('refreshList');
          }
          this.isShow = false;
        } else {
          qNotify.error({
            text: this.$t("users.cooperation_deleted_fail"),
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public isChanged() {
    return compareWithKeys(this.userCompany, this.userCompanyInit, [
      'role_id',
      'user_id',
    ])
  }
}
